/*
 * Dayvee – Geschenkgutschein fest in der Header-Live-Suche
 *
 * Verhalten:
 * - Dayvee Geschenkgutschein wird bei jeder echten Suchanfrage angezeigt.
 * - Immer als letzter Eintrag im Bereich "Produkte".
 * - Falls Shopify den Gutschein ohnehin als Treffer liefert, wird er nur
 *   ans Ende verschoben und nicht doppelt angezeigt.
 * - Desktop und mobil.
 * - Die normale Suchergebnisseite wird nicht verändert.
 */

(function () {
  'use strict';

  var GIFT_CARD_HANDLE = 'geschenkgutschein';
  var FALLBACK_TITLE = 'Dayvee Geschenkgutschein';
  var FALLBACK_IMAGE = 'https://cdn.shopify.com/s/files/1/0974/5393/2870/files/dayvee-geschenkgutschein.png?v=1788928095';
  var giftCardPromise = null;

  function getShopRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (error) {
      return String(url || '')
        .split('?')[0]
        .split('#')[0]
        .replace(/\/+$/, '');
    }
  }

  function getGiftCardPath() {
    return normalizePath(
      getShopRoot() + 'products/' + GIFT_CARD_HANDLE
    );
  }

  function isGiftCardUrl(url) {
    return normalizePath(url) === getGiftCardPath();
  }

  function parseSearchConfig(header) {
    var node = header.querySelector('[data-dyh-search-config]');

    if (!node) {
      return {};
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents);

    if (!Number.isFinite(amount)) {
      return '';
    }

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'de-DE',
        {
          style: 'currency',
          currency: currency || 'EUR'
        }
      ).format(amount / 100);
    } catch (error) {
      return (amount / 100)
        .toFixed(2)
        .replace('.', ',') + ' €';
    }
  }

  function getGiftCardData() {
    if (giftCardPromise) {
      return giftCardPromise;
    }

    var root = getShopRoot();
    var url =
      root +
      'products/' +
      encodeURIComponent(GIFT_CARD_HANDLE) +
      '.js';

    giftCardPromise = fetch(url, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        return response.json();
      })
      .then(function (product) {
        var variants = Array.isArray(product.variants)
          ? product.variants
          : [];

        var prices = variants
          .map(function (variant) {
            return Number(variant.price);
          })
          .filter(Number.isFinite);

        var minPrice = prices.length
          ? Math.min.apply(Math, prices)
          : 1000;

        var maxPrice = prices.length
          ? Math.max.apply(Math, prices)
          : minPrice;

        var image =
          product.featured_image ||
          (Array.isArray(product.images) && product.images.length
            ? product.images[0]
            : '');

        return {
          title: product.title || FALLBACK_TITLE,
          url:
            product.url ||
            root + 'products/' + GIFT_CARD_HANDLE,
          image: image || FALLBACK_IMAGE,
          minPrice: minPrice,
          maxPrice: maxPrice
        };
      })
      .catch(function () {
        return {
          title: FALLBACK_TITLE,
          url:
            root + 'products/' + GIFT_CARD_HANDLE,
          image: FALLBACK_IMAGE,
          minPrice: 1000,
          maxPrice: 20000
        };
      });

    return giftCardPromise;
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);

    if (className) {
      element.className = className;
    }

    if (typeof text === 'string') {
      element.textContent = text;
    }

    return element;
  }

  function createGiftCardLink(product, config) {
    var link = createElement(
      'a',
      'dyh-predictive-product'
    );

    link.href = product.url;
    link.setAttribute(
      'data-dayvee-pinned-gutschein',
      'true'
    );

    /*
     * Explizite Navigation: Die Dayvee-Live-Suche schließt sich beim
     * Fokuswechsel. Dadurch bleibt der Gutschein-Link auch dann sicher
     * klickbar, wenn der Header das Suchpanel unmittelbar schließt.
     */
    link.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(product.url);
    });

    if (product.image) {
      var image = createElement(
        'img',
        'dyh-predictive-image'
      );

      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';

      link.appendChild(image);
    } else {
      link.appendChild(
        createElement(
          'span',
          'dyh-predictive-image-placeholder'
        )
      );
    }

    var copy = createElement(
      'span',
      'dyh-predictive-product-copy'
    );

    copy.appendChild(
      createElement(
        'span',
        'dyh-predictive-product-title',
        product.title
      )
    );

    var meta = createElement(
      'span',
      'dyh-predictive-product-meta'
    );

    var priceText = formatMoney(
      product.minPrice,
      config.currency || 'EUR'
    );

    if (
      priceText &&
      Number(product.maxPrice) >
        Number(product.minPrice)
    ) {
      priceText = 'ab ' + priceText;
    }

    if (priceText) {
      meta.appendChild(
        createElement(
          'span',
          'dyh-predictive-price',
          priceText
        )
      );

      copy.appendChild(meta);
    }

    link.appendChild(copy);

    return link;
  }

  function removeExistingGiftCardEntries(content) {
    var links = content.querySelectorAll(
      'a.dyh-predictive-product'
    );

    links.forEach(function (link) {
      if (
        link.hasAttribute(
          'data-dayvee-pinned-gutschein'
        ) ||
        isGiftCardUrl(link.getAttribute('href'))
      ) {
        var parent = link.parentElement;

        link.remove();

        /*
         * Entfernt nur leere Listen/Produktgruppen, die durch
         * einen vorherigen Pin-Lauf entstanden sind.
         */
        if (
          parent &&
          parent.hasAttribute(
            'data-dayvee-gutschein-list'
          ) &&
          !parent.children.length
        ) {
          var group = parent.closest(
            '[data-dayvee-gutschein-group]'
          );

          if (group) {
            group.remove();
          }
        }
      }
    });
  }

  function ensureProductArea(content) {
    var columns = content.querySelector(
      '.dyh-predictive-columns'
    );

    if (!columns) {
      columns = createElement(
        'div',
        'dyh-predictive-columns is-single'
      );

      /*
       * Bei "keine Treffer" bleibt der Hinweis bestehen.
       * Der Gutschein wird danach und vor dem CTA gezeigt.
       */
      var footer = content.querySelector(
        '.dyh-predictive-footer'
      );

      if (footer) {
        content.insertBefore(columns, footer);
      } else {
        content.appendChild(columns);
      }
    }

    var productColumn = columns.querySelector(
      '.dyh-predictive-column--products'
    );

    if (!productColumn) {
      productColumn = createElement(
        'div',
        'dyh-predictive-column dyh-predictive-column--products'
      );

      var rightColumn = columns.querySelector(
        '.dyh-predictive-column--right'
      );

      if (rightColumn) {
        columns.insertBefore(
          productColumn,
          rightColumn
        );
      } else {
        columns.appendChild(productColumn);
      }
    }

    var productGroup =
      productColumn.querySelector(
        '.dyh-predictive-group'
      );

    if (!productGroup) {
      productGroup = createElement(
        'section',
        'dyh-predictive-group'
      );

      productGroup.setAttribute(
        'data-dayvee-gutschein-group',
        'true'
      );

      productGroup.appendChild(
        createElement(
          'h3',
          'dyh-predictive-heading',
          'Produkte'
        )
      );

      var list = createElement(
        'div',
        'dyh-predictive-list'
      );

      list.setAttribute(
        'data-dayvee-gutschein-list',
        'true'
      );

      productGroup.appendChild(list);
      productColumn.appendChild(productGroup);
    }

    var list = productGroup.querySelector(
      '.dyh-predictive-list'
    );

    if (!list) {
      list = createElement(
        'div',
        'dyh-predictive-list'
      );

      productGroup.appendChild(list);
    }

    var hasRightColumn = !!columns.querySelector(
      '.dyh-predictive-column--right'
    );

    columns.classList.toggle(
      'is-single',
      !hasRightColumn
    );

    return list;
  }

  function removePinnedGiftCard(content) {
    content
      .querySelectorAll(
        '[data-dayvee-pinned-gutschein]'
      )
      .forEach(function (node) {
        node.remove();
      });
  }

  function ensurePinnedGiftCard(form) {
    var header = form.closest(
      '[data-dayvee-header]'
    );

    if (!header) {
      return;
    }

    var input = form.querySelector(
      '[data-dyh-search-input]'
    );

    var content = form.querySelector(
      '[data-dyh-predictive-content]'
    );

    if (!input || !content) {
      return;
    }

    var config = parseSearchConfig(header);
    var minChars = Math.max(
      1,
      Number(config.minChars || 2)
    );

    var query = input.value.trim();

    if (query.length < minChars) {
      removePinnedGiftCard(content);
      return;
    }

    /*
     * Wenn gerade nur der Ladezustand angezeigt wird, warten wir
     * auf den nächsten MutationObserver-Lauf.
     */
    if (
      content.querySelector(
        '.dyh-predictive-loading'
      )
    ) {
      return;
    }

    /*
     * Wichtig: Nicht bei jeder DOM-Änderung den Gutschein wieder
     * entfernen und neu erzeugen. Sonst wird der Link während eines
     * Klicks ausgetauscht und der Browser erhält kein sauberes click.
     * Shopify ersetzt den kompletten Suchinhalt bei einer neuen Suche;
     * dann ist dieses Element automatisch weg und wird neu angelegt.
     */
    if (
      content.querySelector(
        '[data-dayvee-pinned-gutschein]'
      )
    ) {
      return;
    }

    getGiftCardData().then(function (product) {
      if (
        input.value.trim() !== query ||
        input.value.trim().length < minChars
      ) {
        return;
      }

      removeExistingGiftCardEntries(content);

      var list = ensureProductArea(content);

      list.appendChild(
        createGiftCardLink(
          product,
          config
        )
      );
    });
  }

  function initSearchForm(form) {
    if (
      !form ||
      form.dataset.dayveeGutscheinPinReady ===
        'true'
    ) {
      return;
    }

    var content = form.querySelector(
      '[data-dyh-predictive-content]'
    );

    if (!content) {
      return;
    }

    form.dataset.dayveeGutscheinPinReady =
      'true';

    var scheduled = false;

    function schedule() {
      if (scheduled) {
        return;
      }

      scheduled = true;

      window.requestAnimationFrame(
        function () {
          scheduled = false;
          ensurePinnedGiftCard(form);
        }
      );
    }

    var observer = new MutationObserver(
      schedule
    );

    observer.observe(content, {
      childList: true,
      subtree: true
    });

    var input = form.querySelector(
      '[data-dyh-search-input]'
    );

    if (input) {
      input.addEventListener(
        'input',
        schedule
      );

      input.addEventListener(
        'focus',
        schedule
      );
    }

    schedule();
  }

  function init() {
    document
      .querySelectorAll(
        '[data-dayvee-header] [data-dyh-search-form]'
      )
      .forEach(initSearchForm);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();
